import { createContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import { capitalize } from "../../utils/capitalize";

import { deleteAllCookies } from "../../utils/cookies";
import { getEnvironments } from "../../utils/security";
import Swal from "sweetalert2";
import { useNavigation } from "../navigation/NavigationContext";
import { normalizePshbCustomer } from "../../utils/isPshbUser";

const SwalMessage = (allowOutsideClick, icon, title, text) => {
  Swal.fire({
    allowOutsideClick: allowOutsideClick,
    icon: icon,
    title: title,
    text: text,
    color: "#224d7c",
    confirmButtonColor: "#224d7c",
    confirmButtonText: "Continuar",
  });
};

// memory space created
export const UserGlobalContextMemorySpace = createContext();

export const UserGlobalContext = ({children}) =>{


    const [mainLoader, setMainLoader] = useState(true);
    const [sitePSHB, setSitePSHB] = useState(null); 
    const [userPSHB, setUserPSHB] = useState(null);
    const [user, setUser] = useState(null);
    const [originalUser, setOriginalUser] = useState(null);
    const [familiarGroup, setFamiliarGroup] = useState(null);
    const [familiarGroupToken, setFamiliarGroupToken] = useState(null);
    const [familiarGroupComponent, setFamiliarGroupComponent] = useState(null);
    const [clearContext, setClearContext] = useState(false);
    const [reintegro,setReintegro]=useState();
    const [socialMediaModal, setSocialMediaModal] = useState(false);
    const [socialMediaData, setSocialMediaData] = useState({});
    const [openHelper,setOpenHelper]=useState(false);
    const [footerConfiguration,setFooterConfiguration] = useState({})
    const [environments, setEnvironments] = useState({});
    const [credencial, setCredencial] = useState(null);
    const [loadCredencial, setLoadCredencial] = useState(false);
    const credencialFetchedRef = useRef(false);
    const [hasAutorizaciones, setHasAutorizaciones] = useState(null);
    const autorizacionesFetchedRef = useRef(false);

    const { navigate } = useNavigation();

    const logout = () =>{
        setSitePSHB(null);
        setUserPSHB(null);
        setUser(null);
        setOriginalUser(null);
        setFamiliarGroup(null);
        setFamiliarGroupToken(null);
        setFamiliarGroupComponent(null);
        setClearContext(false);
        setReintegro();
        setCredencial(null);
        credencialFetchedRef.current = false;
        setHasAutorizaciones(null);
        autorizacionesFetchedRef.current = false;
        localStorage.clear();
        deleteAllCookies();
    }

    const getFooterConfiguration=async ()=>{
        const footer= await axios({
            url: process.env.REACT_APP_STRAPI_QA+"/footers?estado=PU",
            method: 'get',                
        });    

        setFooterConfiguration(footer.data[0])
    }

    const getData = async () => {
        const keys = [
            "REACT_APP_USER_SERVER_LOG",
            "REACT_APP_PASSWORD_SERVER_LOG",
            "REACT_APP_CAPTCHA",
            "REACT_APP_GOOGLE_CLIENT_ID",
            "REACT_APP_APPLE_CLIENT_ID",
            "REACT_APP_FACEBOOK_CLIENT_ID",
        ];

        const environmentsResponse = await getEnvironments(keys);

        if (!environmentsResponse) {
            SwalMessage(
                false,
                "warning",
                '<h5 style="color: #224d7c">Error de conexión</h5>',
                "Ha ocurrido un error inésperado, espera unos momentos y vuelve a intentarlo."
            );
            return;
        }

        setEnvironments(environmentsResponse);
        window.env = environmentsResponse;   

        let sessionLocal = localStorage.getItem("enc");

        getFooterConfiguration();
        if(sessionLocal){



            axios({
                url: process.env.REACT_APP_STRAPI_QA+process.env.REACT_APP_STRAPI_QA_ENDPOINT_ENCSESSION,
                method: 'POST',
                data: {enc: sessionLocal}
            })
            .then((res)=>{
                // console.log("res.data.result", res.data.result)

                if(res.data.result.responseCode == 200){
                    const userData = { ...res.data.result };

                    if (userData.data?.Customers) {
                        userData.data.Customers = normalizePshbCustomer(
                            userData.data.Customers
                        );
                    }

                    setSitePSHB(false);
                    setUserPSHB(false);
                    setUser({user: userData});
                    setOriginalUser({user: userData});
                    setMainLoader(false)

                }else{
                    setMainLoader(false)
                    localStorage.clear();
                }


            }).catch((err)=>{
                // console.log("err", err)
                localStorage.clear();
                setMainLoader(false);
            })
        }else{
            setMainLoader(false)
        }
    }

    // Capitaliza los customers si la sesión ya estaba iniciada
useEffect(() => {
  if (
    user?.user?.data?.Customers &&
    (
      user.user.data.Customers.firstName !== capitalize(user.user.data.Customers.firstName) ||
      user.user.data.Customers.lastName !== capitalize(user.user.data.Customers.lastName)
    )
  ) {    

    const customersCapitalized = {
      ...user.user.data.Customers,
      firstName: capitalize(user.user.data.Customers.firstName),
      lastName: capitalize(user.user.data.Customers.lastName)
    };

    setUser(prev => ({
      ...prev,
      user: {
        ...prev?.user,
        data: {
          ...prev?.user?.data,
          Customers: customersCapitalized
        }
      }
    }));
    setOriginalUser(prev => ({
      ...prev,
      user: {
        ...prev?.user,
        data: {
          ...prev?.user?.data,
          Customers: customersCapitalized
        }
      }
    }));
  }
}, [user]);

    useEffect(()=>{
        getData();
    }, [clearContext])

    useEffect(() => {
        const dni = user?.user?.data?.Customers?.dni;
        if (!dni || credencialFetchedRef.current) return;
        credencialFetchedRef.current = true;
        setLoadCredencial(true);
        // 1. Esperar a que external-auth/auth responda, usar su token para la credencial
        axios({
            url: process.env.REACT_APP_STRAPI_QA + "/external-auth/auth",
            method: "POST",
        })
        .then((authRes) => {
            const gatewayToken = authRes?.data?.token;
            return axios({
                url: `${process.env.REACT_APP_GATEWAY_QA}/customers/api/v1/getinfocredentialbydni?dni=${dni}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${gatewayToken}`,
                    Accept: "application/json",
                },
            });
        })
        .then((res) => setCredencial(res.data.data))
        .catch(() => setCredencial(undefined))
        .finally(() => setLoadCredencial(false));
    }, [user]);

    useEffect(() => {
        const dni = user?.user?.data?.Customers?.dni;
        if (!dni || autorizacionesFetchedRef.current) return;
        autorizacionesFetchedRef.current = true;

        const appToken  = user?.user?.data?.appToken ?? "";
        const userToken = user?.user?.data?.Token ?? "";
        const params    = new URLSearchParams({ dni, limit: 1, offset: 0 }).toString();

        axios({
            url: `${process.env.REACT_APP_GATEWAY_2}/patient/api/v1/autorizaciones/getautorizacionesbi?${params}`,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                USERTOKEN: userToken,
                Authorization: `Bearer ${appToken}`,
            },
        })
        .then((res) => {
            const total = res?.data?.data?.total ?? 0;
            setHasAutorizaciones(total > 0);
        })
        .catch(() => setHasAutorizaciones(false));
    }, [user]);


 useEffect(()=>{
         const redirect=sessionStorage.getItem("redirectSpecial");
              
        if(user && redirect)
          {
            sessionStorage.removeItem("redirectSpecial");
            // window.location.href = redirect;
            navigate(redirect);
          }
        },[user])

    return(
        <UserGlobalContextMemorySpace.Provider 
            value={
                {
                    mainLoader, setMainLoader,
                    socialMediaData, setSocialMediaData,
                    socialMediaModal, setSocialMediaModal,
                    sitePSHB, setSitePSHB,
                    userPSHB, setUserPSHB,
                    user, setUser,
                    familiarGroup, setFamiliarGroup,
                    familiarGroupToken, setFamiliarGroupToken,
                    familiarGroupComponent, setFamiliarGroupComponent,
                    clearContext, setClearContext,
                    reintegro,setReintegro,
                    logout,
                    openHelper,
                    setOpenHelper,
                    footerConfiguration,
                    setFooterConfiguration,
                    originalUser, setOriginalUser,
                    environments, setEnvironments,
                    credencial, loadCredencial,
                    hasAutorizaciones
                }}>
            {children}
        </UserGlobalContextMemorySpace.Provider>
    );
}